import { isCorrect } from 'helpers'
import cn from 'helpers/cn'
import { FC } from 'react'
import { ITFNSAnswered, ITFNSUnanswered } from 'types/tests/anj'

interface props {
  id: string
  number: number
  question: ITFNSAnswered | ITFNSUnanswered
  showResult?: boolean
}

const TFNSQuestion: FC<props> = ({ id, number, question, showResult }) => {
  const correct = showResult && question.answered && isCorrect(question)

  const correctClass = showResult && 'text-green-600 border-green-600 border-2 bg-green-50'
  const incorrectClass = showResult && 'text-rose-600 border-rose-600 border-2 bg-rose-50'

  const numberClass = showResult
    ? correct
      ? 'ring-offset-2 ring-2 ring-green-600 rounded bg-green-600 w-8 shrink-0 text-center text-black select-none'
      : 'ring-offset-2 ring-2 ring-rose-600 rounded bg-rose-600 w-8 shrink-0 text-center text-black select-none'
    : 'ring-offset-2 ring-2 ring-jajko rounded bg-jajko w-8 shrink-0 text-center text-black select-none'

  return (
    <div
      style={{ borderLeft: !showResult ? undefined : correct ? '4px solid green' : '4px solid red' }}
      id={id}
      data-type="question"
            data-qtype={question.type}
data-number={number}
      className="flex flex-col w-full items-start space-x-2 px-5 justify-start pb-5"
    >
      <div className="flex items-start space-x-4 py-4">
        <span className={numberClass}>{number}</span>
        <span className="font-semibold -mt-0 select-none" dangerouslySetInnerHTML={{ __html: question.question }} />
      </div>
      <div className="flex items-center justify-evenly mt-2">
      {["true", "false", "not stated"].map((choice: string, l: number) => (
        <div key={`${id}_${l}`} className="flex items-center mb-2 pl-10 cursor-pointer">
          <input
            disabled={showResult}
            id={`${id}_${l}`}
            onInput={(e) => e.currentTarget.closest('[data-type="question"]')?.setAttribute('data-answer', e.currentTarget.checked ? e.currentTarget.value : '')}
            name={id}
            type="radio"
            className="peer disabled:hidden cursor-pointer h-4 w-4 accent-kura shrink-0"
            value={l}
            onChange={() => {}}
          />
          <label
            htmlFor={`${id}_${l}`}
            dangerouslySetInnerHTML={{ __html: choice }}
            className={cn(
              'peer-checked:font-bold select-none cursor-pointer rounded px-2',
              !showResult
                ? "peer-checked:text-kura"
                : correct && question.answer === l
                ? correctClass
                : !correct && question.answered && question.answer === l
                ? incorrectClass
                : !correct && (question.correctAnswer as any).includes(l)
                ? cn(correctClass, "border-0")
                : undefined
            )}
          />
        </div>
      ))}
      </div>
    </div>
  )
}

export default TFNSQuestion
